import logger from '@/services/logger';
import { httpService } from '../common/http.service';
import type { ApiResponse } from '../common/types/api-response';
import type { GetLeaderboardParams, Leaderboard } from './types/leaderboard';

const toQueryParams = (params: GetLeaderboardParams): Record<string, string> => {
  const query: Record<string, string> = {
    scopeType: params.scopeType || 'global',
  };
  if (params.scopeId) query.scopeId = params.scopeId;
  if (params.limit) query.limit = String(params.limit);
  return query;
};

export async function getLeaderboard(params: GetLeaderboardParams = {}) {
  try {
    const res = await httpService.get<ApiResponse<Leaderboard>>('leaderboard', toQueryParams(params));
    return res.data.data;
  } catch (err) {
    logger.error({
      message: '[LeaderboardApi] getLeaderboard error',
      data: { params },
      error: err as Error,
    });
    throw err;
  }
}
